import React from 'react';

import SignUp from '../../components/Auth/SignUp';

const Activate = () => (
  <SignUp />
);

export default Activate;